<template>
  <b-modal
    id="CloneLeadModal"
    :title="modalTitle"
    size="lg"
    hide-footer
  >
    <b-card>
      <validation-observer
        ref="FormValidation"
      >
        <b-form
          enctype="multipart/form-data"
          autocomplete="off"
          @submit.prevent="checkValidation"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                :label="t('Assign Services')"
                label-for="vi-assign-services"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Assign Services"
                  vid="vi-assign-services"
                  rules="required"
                >
                  <v-select
                    v-model="form.lead_service"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="service_name"
                    :multiple="true"
                    :placeholder="t('Select Services')"
                    :reduce="s => s.id"
                    :options="services"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group
                :label="t('Financial Year')"
                label-for="vi-financial-year"
                class="required"
              >
                <validation-provider
                  #default="{ errors }"
                  class="input-group"
                  name="Financial Year"
                  vid="vi-financial-year"
                  rules="required"
                >
                  <v-select
                    v-model="form.financial_year"
                    class="p-0 border-0 w-100"
                    :class="errors[0] ? 'border-red-vselect' : ''"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="label"
                    :placeholder="t('Select Financial Year')"
                    :reduce="item => item.id"
                    :options="financialYear"
                  />
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="text-center"
            >
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ t('Submit') }}
              </b-button>
              <b-button
                type="button"
                variant="outline-secondary"
                @click="modalCancel"
              >
                {{ t('Cancel') }}
              </b-button>
            </b-col>
          </b-row></b-form>
      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { useUtils } from '@core/libs/i18n'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import constants from '@/constants'
import { hideLoader, showLoader } from '@/utils/common'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: ['cloneModalData'],
  setup() {
    const { t } = useUtils()
    return { t }
  },
  data() {
    return {
      openModal: false,
      modalTitle: '',
      modalData: [],
      services: [],
      financialYear: [],
      form: {
        id: null,
        lead_service: null,
        financial_year: null,
      },
    }
  },
  watch: {
    cloneModalData: {
      handler(val) {
        this.modalTitle = val.name
        this.modalData = val
        this.openModal = true
        this.form.id = this.modalData.lead_id
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (a, componentId) => {
      if (componentId === 'CloneLeadModal') {
        this.openModal = false
        this.form = {
          id: null,
          lead_service: null,
          financial_year: null,
        }
      }
    })
    this.financialYear = constants.FinancialYearList
    store.dispatch('CompanyuserManage/getServices').then(response => {
      if (response.data.code === '200') {
        this.services = response.data.data
      }
    })
  },
  methods: {
    async onSubmit() {
      showLoader()
      await store.dispatch('ManageLeads/cloneLead', this.form).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.$bvModal.hide('CloneLeadModal')
          // this.$root.$emit('refreshLeadData')
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: '',
            },
          })
          this.$root.$emit('refreshLeadsList')
          this.$refs.FormValidation.reset()
        } else {
          hideLoader()
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: response.data.msg,
              icon: 'Danger',
              variant: 'danger',
              text: '',
            },
          })
        }
      }).catch(e => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: e.msg,
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
    modalCancel() {
      this.$bvModal.hide('CloneLeadModal')
    },
    checkValidation() {
      this.$refs.FormValidation.validate().then(success => {
        if (success) {
          this.onSubmit()
        }
      })
    },
  },
}
</script>
